import { EmeraldIcon } from "@emerald-react/icon";
import { useSortableItem } from "@hooks/useSortable";
import { EditColumnFieldProps } from "@survey-types/survey.core.types";
import classNames from "classnames";

const EditColumnField = ({
  field,
  isDragDisabled,
  side,
  onToggle,
}: EditColumnFieldProps) => {
  const { attributes, listeners, setNodeRef, style, isDragging } =
    useSortableItem(field.fieldId);

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={classNames("edit-column group hover:bg-gray-100", {
        "opacity-50": isDragging,
      })}
    >
      {!isDragDisabled && side === "right" && (
        <div
          {...attributes}
          {...listeners}
          className="shrink-0 cursor-grab active:cursor-grabbing p-0"
        >
          <EmeraldIcon icon="drag_indicator" className="text-slate-400" />
        </div>
      )}

      <div className="grow">
        <div className="text-sm text-data">{field.fieldLabel}</div>
      </div>

      <button
        className="shrink-0 cursor-pointer p-0 bg-transparent border-none invisible group-hover:visible"
        onClick={onToggle}
        aria-label={
          side === "left"
            ? "Add to visible columns"
            : "Remove from visible columns"
        }
      >
        {side === "left" ? (
          <EmeraldIcon
            icon="arrow_right_alt"
            type="filled"
            variant="icon"
            className="hover:bg-gray-200 hover:rounded-full gray-200! p-1"
          />
        ) : (
          <EmeraldIcon icon="close" type="outlined" variant="symbol" />
        )}
      </button>
    </div>
  );
};

export default EditColumnField;
